/**
 * Work only for OrthographicCamera
 */
export var OrthographicCameraResizeMode;
(function (OrthographicCameraResizeMode) {
    OrthographicCameraResizeMode[OrthographicCameraResizeMode["screenSize"] = 0] = "screenSize";
    OrthographicCameraResizeMode[OrthographicCameraResizeMode["responsiveHeigth"] = 1] = "responsiveHeigth";
    OrthographicCameraResizeMode[OrthographicCameraResizeMode["responsiveWidth"] = 2] = "responsiveWidth";
})(OrthographicCameraResizeMode || (OrthographicCameraResizeMode = {}));
export class CameraUtils {
    static updateCameraSize(width, height, camera, orthographicMode = OrthographicCameraResizeMode.responsiveWidth) {
        if (camera.isPerspectiveCamera) {
            camera.aspect = width / height;
            camera.updateProjectionMatrix();
            return;
        }
        if (camera.isOrthographicCamera) {
            switch (orthographicMode) {
                case OrthographicCameraResizeMode.responsiveHeigth: {
                    let aspect = width / height;
                    let frustumSize = camera.top * 2;
                    camera.left = -frustumSize * aspect / 2;
                    camera.right = frustumSize * aspect / 2;
                    break;
                }
                case OrthographicCameraResizeMode.responsiveWidth: {
                    let aspect = height / width;
                    let frustumSize = camera.right * 2;
                    camera.top = frustumSize * aspect / 2;
                    camera.bottom = -frustumSize * aspect / 2;
                    break;
                }
                case OrthographicCameraResizeMode.screenSize:
                default:
                    camera.left = width / -2;
                    camera.right = width / 2;
                    camera.top = height / 2;
                    camera.bottom = height / -2;
            }
            camera.updateProjectionMatrix();
            return;
        }
        console.error("Camera not supported. Cannot update it.");
    }
}
//# sourceMappingURL=CameraUtils.js.map